module.exports = __webpack_public_path__ + "assets/c14daf3b332053a13485d8862b360435.png";